module.exports = __webpack_public_path__ + "media/images/icons/expander_up-0bba601a16ee8bd72a6ee4151999f962.svg";